import { Directive, ElementRef, EventEmitter, HostListener, inject, Output } from '@angular/core';

@Directive({
  selector: '[libFocusOutside]',
  standalone: true,
  host: {
    '(keydown)': 'onKeyDown($event)',
  },
})
export class FocusOutsideDirective {
  @Output() libFocusOutside = new EventEmitter<void>();

  readonly elementRef = inject(ElementRef);

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Tab') {
      // Wait until the next cycle to check the focused element
      setTimeout(() => {
        const focusedElement = document.activeElement;
        const isInsideElement = this.elementRef.nativeElement.contains(focusedElement);

        if (!isInsideElement) {
          this.libFocusOutside.emit();
        }
      });
    }
  }
}
